import { INameValue, EAgencies } from "./common.types";

export interface IBankResponseItem
  extends ICreateBankRequest<INameValue<EAgencies>> {
  id: number;
}

export interface ICreateBankRequest<Agency = EAgencies> {
  agency: Agency;
  bic: string;
  name: string;
  address: string;
}

export enum EBankRequestField {
  bic = "bic",
  bank_name = "bank_name",
  address = "address",
}

export interface IBankRequestParams {
  agency: EAgencies;
  filter?: string;
  field: EBankRequestField;
}
